import { render, staticRenderFns } from "./onboarding-modal.vue?vue&type=template&id=990358d4"
import script from "./onboarding-modal.js?vue&type=script&lang=js&external"
export * from "./onboarding-modal.js?vue&type=script&lang=js&external"
import style0 from "./onboarding-modal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports